<template>
    <div v-if="subjectTracing">
        <BlockUI :blocked="isLoading">
<!--            <panel>-->
                <ScrollPanel :key="componentUpdate" style="width: 98%; height: 70vh">

                    <table class="p-pt-3 pupil" id="behaviorScores">
                        <tr class="header title">
                            <th colspan="6">
                                <h2 style="text-align: center">
                                    הליכות
                                </h2>
                            </th>
                        </tr>
                        <tr class="header">
                            <th>
                                נושא
                            </th>
<!--                            <th>-->
<!--                                כמות-->
<!--                            </th>-->
                            <th>
                                ציון
                            </th>
                            <th>
                                תיאור
                            </th>
                            <th>
                                מדווח
                            </th>
                            <th>
                                עודכן ב-
                            </th>

                        </tr>
                        <tr v-for="(track, index) in subjectTracingFilter" >
                            <!--                    <div>-->

                            <th>
                                {{track.hebrewName }}
                            </th>
<!--                            <th>-->
<!--                                {{track && behaviorPupilStatistics[track.id] }}-->
<!--                            </th>-->
                            <td style="width: 15%">
                                {{track.id && report && report.behaviorScores[track.id] && report.behaviorScores[track.id].score}}
<!--                                <AutoComplete-->
<!--                                        disabled="true"-->
<!--                                        placeholder="ציון"-->
<!--                                        @item-select="inputData($event,'score' ,track, 'behaviorScores')"-->
<!--                                        v-model="track.id && report && report.behaviorScores[track.id] && report.behaviorScores[track.id].score"-->
<!--                                        :suggestions="filteredBehaviorOptions"-->
<!--                                        @complete="searchBehaviorScoreOption($event)"-->
<!--                                        :dropdown="true"-->
<!--                                        forceSelection-->
<!--                                ></AutoComplete>-->
<!--                                <InputText placeholder="ציון" @change="inputData($event,'score' ,track, 'behaviorScores')"-->
<!--                                            v-model="track.id && report && report.behaviorScores && report.behaviorScores[track.id] && report.behaviorScores[track.id].score && report.behaviorScores[track.id].score"/>-->
                            </td>
                            <td style="width: 60%">
                                {{track.id && report && report.behaviorScores && report.behaviorScores[track.id] && report.behaviorScores[track.id].description && report.behaviorScores[track.id].description}}
<!--                                <Textarea-->
<!--                                        disabled="true"-->
<!--                                        style="width:100%"-->
<!--                                        rows="1"-->
<!--                                        placeholder="תיאור" @change="inputData($event,'description' ,track, 'behaviorScores')"-->
<!--                                            v-model="track.id && report && report.behaviorScores && report.behaviorScores[track.id] && report.behaviorScores[track.id].description && report.behaviorScores[track.id].description"/>-->
                            </td>
                            <td>
                                {{getFullName(report && report.behaviorScores && report.behaviorScores[track.id])}}
                            </td>
                            <td >
                                {{ getDate(report && report.behaviorScores && report.behaviorScores[track.id]) }}
                            </td>

                        </tr>
                    </table>
                    <table class="pupil" id="topicsScores">
                        <tr class="header title">
                            <th colspan="6">
                                <h2 style="text-align: center">
                                    מקצועות
                                </h2>
                            </th>
                        </tr>
                        <tr class="header">
                            <th>
                                נושא
                            </th>
<!--                            <th>-->
<!--                                ממוצע-->
<!--                            </th>-->
                            <th>
                                ציון
                            </th>
                            <th>
                                תיאור
                            </th>
                            <th>
                                מדווח
                            </th>
                            <th>
                                עודכן ב-
                            </th>
                        </tr>
                        <tr v-for="(lesson, index) in subjectTopicsFilter" >
                            <th>
                                {{ lesson.hebrewName }}
                            </th>
<!--                            <th>-->
<!--                                {{ lesson && topicsPupilStatistics[lesson.id] && topicsPupilStatistics[lesson.id] }}-->
<!--                            </th>-->
                            <td style="width: 15%">
                                {{lesson.id && report && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].score}}
<!--                            <AutoComplete-->
<!--                                    disabled="true"-->
<!--                                        @item-select="inputData($event,'score' ,lesson, 'topicsScores')"-->
<!--                                        v-model="lesson.id && report && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].score"-->
<!--                                        :suggestions="filteredTopicsOptions"-->
<!--                                        @complete="searchTopicScoreOption($event)"-->
<!--                                        :dropdown="true"-->
<!--                                        forceSelection-->
<!--                                >-->
<!--                                </AutoComplete>-->
                                <!--                            <input-text placeholder="ציון" @change="inputData($event,'score' ,lesson, 'topicsScores')"-->
                                <!--                                        v-model="lesson.id && report && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].score"/>-->
                                <!--                            </td>-->
                            <td style="width: 60%">
                            {{lesson && report && report.topicsScores && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].description}}
<!--                                <Textarea-->
<!--                                        disabled="true"-->
<!--                                        style="width:100%"-->
<!--                                        rows="1"-->
<!--                                        placeholder="תיאור"-->
<!--                                            @change="inputData($event,'description', lesson, 'topicsScores')"-->
<!--                                            v-model="lesson.id && report && report.topicsScores&& report.topicsScores[lesson.id] && report.topicsScores[lesson.id].description"/>-->
                            </td>
                            <td>
                                {{getFullName(report && report.topicsScores  && report.topicsScores[lesson.id])}}
                            </td>
                            <td >
                                {{getDate(report && report.topicsScores &&   report.topicsScores[lesson.id]) }}
                            </td>
                        </tr>
                    </table>
                    <table class="pupil" id="ratedScores">
                        <tr class="header title">
                            <th colspan="6">
                                <h2 style="text-align: center">
                                    הגדים
                                </h2>
                            </th>
                        </tr>
                        <tr class="header">
                            <th>
                                נושא
                            </th>
                            <!--                            <th>-->
                            <!--                                ממוצע-->
                            <!--                            </th>-->
                            <th>
                                ציון
                            </th>
                            <th>
                                תיאור
                            </th>
                            <th>
                                מדווח
                            </th>
                            <th>
                                עודכן ב-
                            </th>
                        </tr>

                        <tr v-for="(lesson, index) in reportRatingsFiltered" >
                            <th>
                                {{ lesson.subjectName }}: {{ lesson.hebrewName }}
                            </th>
                            <!--                            <th>-->
                            <!--                                {{ lesson && topicsPupilStatistics[lesson.id] && topicsPupilStatistics[lesson.id] }}-->
                            <!--                            </th>-->
                            <td style="width: 15%">
                                <Rating readonly disabled  :stars="lesson.starsCount"
                                        v-model="lesson.id && report && report.ratedScores[lesson.id] && report.ratedScores[lesson.id].score" :cancel="false"/>
                                <!--                            <AutoComplete-->
                                <!--                                    disabled="true"-->
                                <!--                                        @item-select="inputData($event,'score' ,lesson, 'topicsScores')"-->
                                <!--                                        v-model="lesson.id && report && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].score"-->
                                <!--                                        :suggestions="filteredTopicsOptions"-->
                                <!--                                        @complete="searchTopicScoreOption($event)"-->
                                <!--                                        :dropdown="true"-->
                                <!--                                        forceSelection-->
                                <!--                                >-->
                                <!--                                </AutoComplete>-->
                                <!--                            <input-text placeholder="ציון" @change="inputData($event,'score' ,lesson, 'topicsScores')"-->
                                <!--                                        v-model="lesson.id && report && report.topicsScores[lesson.id] && report.topicsScores[lesson.id].score"/>-->
                                <!--                            </td>-->
                            <td style="width: 60%">
                                {{lesson && report && report.ratedScores && report.ratedScores[lesson.id] && report.ratedScores[lesson.id].description}}
                                <!--                                <Textarea-->
                                <!--                                        disabled="true"-->
                                <!--                                        style="width:100%"-->
                                <!--                                        rows="1"-->
                                <!--                                        placeholder="תיאור"-->
                                <!--                                            @change="inputData($event,'description', lesson, 'topicsScores')"-->
                                <!--                                            v-model="lesson.id && report && report.topicsScores&& report.topicsScores[lesson.id] && report.topicsScores[lesson.id].description"/>-->
                            </td>
                            <td>
                                {{getFullName(report && report.ratedScores  && report.ratedScores[lesson.id])}}
                            </td>
                            <td >
                                {{getDate(report && report.ratedScores &&   report.ratedScores[lesson.id]) }}
                            </td>
                        </tr>
                    </table>
<!--                    <table class="p-pt-3 pupil" id="presenceScores">-->
<!--                        <tr class="header title">-->
<!--                            <th colspan="2">-->
<!--                                <h2 style="text-align: center">-->
<!--                                    נוכחות-->
<!--                                </h2>-->
<!--                            </th>-->
<!--                        </tr>-->
<!--                        <tr class="header">-->
<!--                            <th>-->
<!--                                נושא-->
<!--                            </th>-->
<!--                            <th>-->
<!--                                כמות-->
<!--                            </th>-->
<!--                        </tr>-->
<!--                        <tr v-for="(presence, index) in presenceFilter" :key="id">-->
<!--                            &lt;!&ndash;                    <div>&ndash;&gt;-->
<!--                            <th>-->
<!--                                {{ presence.hebrewName }}-->
<!--                            </th>-->
<!--                            <th>-->
<!--                                {{presence &&  presencePupilStatistics[presence.id] }}-->
<!--                            </th>-->
<!--                        </tr>-->
<!--                    </table>-->
                    <div class=" p-d-flex p-jc-center p-ai-center p-col">
                        <Textarea                                     disabled="true"
                                                                      class="p-m-3" style="width: 70%" id="reportNote" placeholder="הערכת מחנך" @change="inputSummaryReport($event)"
                                  v-model="report && report.summaryReport"/>
                    </div>
                </ScrollPanel>
<!--            </panel>-->
        </BlockUI>
        <!--        <div>2- {{subjectTracing}}</div>-->
        <!--        <div>3- {{// presenceStatus}}</div>-->
        <!--        <div>4- reportNote</div>-->

    </div>
</template>

<script>
import {mapState} from "vuex";
import {getReportByPupil, postData} from "@/views/report/pupilReport/pupilReport.js";
import {getUserFullName} from "@/utils/parseObj";
import {dateToHebrewAndTime, dateToOnlyHebrewAndTime} from "@/utils/hebrewDateFormat";
import Service from "@/service/Service";
const NOTE_TYPE = "reportNote"

export default {
    name: "pupilList",
    data() {
        return {
            isLoading: false,
            report: null,
            NOTE_TYPE: NOTE_TYPE,
            topicsOptions: [
                'טוב מאוד',
                'כמעט טוב מאוד',
                'טוב',
                "כמעט טוב",
                "כמעט מספיק",
                "לא מספיק",
            ],
            behaviorOptions: [
                'א',
                'ב',
                'ג',
            ],
            filteredTopicsOptions: null,
            filteredBehaviorOptions: null,
            componentUpdate: 0,
            behaviorPupilStatistics: {},
            presencePupilStatistics: {},
            topicsPupilStatistics: {},
        }
    },
    mounted() {
        this.service = new Service();
    },
    created() {
    },
    props: {
        refreshData: {
            type: Number,
            default: 0
        },
        selectedGrade: {
            type: Object
        },
        selectedPupil: {
            type: Object
        },
        selectedReportName: {
            type: Object
        },
    },
    computed: {
        reportRatingsFiltered() {
            console.log("this.selectedSubject?.id", this.selectedSubject?.id)

            return this.reportRatings.filter(rate => {
                const gradesArr = rate?.grades?.split(',')
                return gradesArr.includes(this.selectedGrade.id)
            }).sort((a, b) => {
                if (a.subjectName < b.subjectName) {
                    return -1;
                }

                if (a.subjectName > b.subjectName) {
                    return 1;
                }

                return 0;
        })

        },
        presenceFilter(){
            return this.presenceStatus.filter((subject) => subject.reportActive === true)
        },
        subjectTopicsFilter(){
            return this.subjectLesson.filter((subject) => subject.reportActive === true)
        },
        subjectTracingFilter(){
            return this.subjectTracing.filter((subject) => subject.reportActive === true)
        },
        ...mapState(["intro", "pupils", "user", "gradeOptions", "subjectLesson",
            "presenceStatus",  "reportRatings",
            "subjectTracing"]),
    },
    watch: {
        refreshData() {
            this.getDataByPupil()
        },
        selectedGrade(newValue, oldValue) {
            if (oldValue !== null)
            this.getDataByPupil()
        }, selectedPupil(newValue, oldValue) {
            if (oldValue !== null)
            this.getDataByPupil()
        }, selectedReportName(newValue, oldValue) {
            this.getDataByPupil()
        },
    },
    methods: {
        searchTopicScoreOption(event) {
                setTimeout(() => {
                    if (!event.query.trim().length) {
                        this.filteredTopicsOptions = [...this.topicsOptions];
                    }
                    else {
                        this.filteredTopicsOptions = this.topicsOptions
                            .filter((option) => {
                            return option.startsWith(event.query);
                        });
                    }
                }, 250);
            },searchBehaviorScoreOption(event) {
                setTimeout(() => {
                    if (!event.query.trim().length) {
                        this.filteredBehaviorOptions = [...this.behaviorOptions];
                    }
                    else {
                        this.filteredBehaviorOptions = this.behaviorOptions
                            .filter((option) => {
                            return option.startsWith(event.query);
                        });
                    }
                }, 250);
            },
        getFullName(userId) {
            return userId ? getUserFullName(userId.user) : '--'
        },
        getDate(dateLong) {
            return dateLong ? dateToOnlyHebrewAndTime(dateLong.ts) : '--'
        },
        checkIfAllSelected(){
        },
        // getLessonScore(lesson) {
        //     return this.report && this.report.topicsScores[lesson?.id] && this.report.topicsScores[lesson?.id].score
        // }, getLessonDescription(lesson) {
        //     return this.report && this.report.topicsScores[lesson?.id] && this.report.topicsScores[lesson?.id].description
        // },
        async inputSummaryReport(event) {
            const obj = {
                "name": this.selectedReportName.id,
                "pupil": this.selectedPupil.id,
                "summaryReport": event.target.value,
                "typeOfScore": this.NOTE_TYPE,
            }
            try {
                const {data} = await postData(obj)
            } catch (e) {

            }
        },
        async inputData(event, isField, subject, type) {
            const value = event?.target?.value ? event?.target?.value : event.value
            let scoresToUpdate
            const originalObj = this.report?.[type]?.[subject.id]
            if (originalObj){
                scoresToUpdate = originalObj
                scoresToUpdate[isField] = value
                scoresToUpdate["user"] = this.user.id,
                scoresToUpdate["ts"] = new Date().getTime()
            } else {
                scoresToUpdate = {
                    [isField]: value,
                    "user": this.user.id,
                    "ts": new Date().getTime()
                }
            }


            const obj = {
                "name": this.selectedReportName.id,
                "pupil": this.selectedPupil.id,
                "typeOfScore": type,
                "scoresToUpdate": {
                    [subject.id]: scoresToUpdate
                },
                // "summaryReport": this.summary[pupil.id]
            }
            const a = this.report
            if (a[type] === undefined){
                a[type] = {}
            }
            if (a[type][subject.id] === undefined){
                a[type][subject.id] = {}
            }
            a[type][subject.id] = scoresToUpdate

            this.report = Object.assign({}, a,);
            try {
                const {data} = await postData(obj)
            } catch (e) {
            }
        },
        async getBehaviorStatistics(){
           await this.service
                .getTotalTracingPupil(this.selectedPupil.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                .then((data) => {
                    this.behaviorPupilStatistics = {}
                    data.forEach(item => {
                            this.behaviorPupilStatistics[item.id] = (item.total)
                    })
                });
        },
        async getTopicsStatistics(){
           await this.service
                .getTotalTestPupil(this.selectedPupil.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                .then((data) => {
                    this.topicsPupilStatistics = {}
                    data.forEach(item => {
                        this.topicsPupilStatistics[item.id] = (item.avg)
                    })
                });
        },
        async getPresenceStatistics(){
            await this.service
                .getTotalPresencePupil(this.selectedPupil.id, this.selectedReportName.startDate, this.selectedReportName.endDate)
                .then((data) => {
                    this.presencePupilStatistics = {}
                    data.forEach(item => {
                        this.presencePupilStatistics[item.id] = (item.total)
                    })
                });
        },
        getReportByPupil(){
            return new Promise(async (resolve, reject) => {
                try {
                        const {data} = await getReportByPupil(this.selectedReportName.id, this.selectedPupil.id)
                        this.report = data
                    resolve();


                } catch (e) {
                    reject(e);
                }
            });
        },
        async getDataByPupil() {
            this.isLoading = true
            try {

                await Promise.all([
                    this.getReportByPupil(),
                    this.getBehaviorStatistics(),
                    this.getTopicsStatistics(),
                    // this.getPresenceStatistics()
                    ]
                )

                this.isLoading = false
            } catch (e) {

            }
        }
    },
}
</script>

<style scoped>
.pupil {
    width: 100%;
}

.pupil td, .pupil th {
    padding: 8px;
}

.pupil tr:nth-child(even) {
    background-color: #f2f2f2;
}

.pupil tr:hover {
    background-color: #ddd;
}

.pupil th {
    background-color: #e5e5e5;
}

.title{
    filter: brightness(0.90);
}

#topicsScores .header th {
    background-color: #fff4ce !important;
    color: black !important;
}

#behaviorScores .header th {
    background-color: #ffe6fb !important;
    color: black !important;
}

#ratedScores .header th {
    background-color: #e6f6ff !important;
    color: black !important;
}

#presenceScores .header th {
    background-color: #e7f8ef !important;
    color: black !important;
}

#reportNote {
    background-color: #fff7f5 !important;
    color: black !important;
}
</style>